import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AttachmentsViewModalComponent } from './attachments-view-modal/attachments-view-modal.component';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonSummaryService } from 'src/app/services/common/common-summary.service';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { CommonService } from '../../services/common.service';
import { UserService } from '../../services/user.service';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss']
})
export class AttachmentsComponent implements OnInit {
  collapesedOrNot: boolean;
  AttachmentForm: UntypedFormGroup;
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  permission: string = "";
  userType: string = "";
  AppStatus;
  AttachmentTypeList = [];
  ModuleName:string;
  module: string;
  MODULE_ID: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe
  ) { }
  ngOnInit() {
    /* this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    }); */

    this.ApplicationID =this.commonService.appId;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.module = params['module'];
     //   this.appid = params['id'];
        if (this.module == "ist"){
          this.MODULE_ID = "2";
        }
        if (this.module == "grants"){
          this.MODULE_ID = "4";
        }
      }
    });

    this.tempoperations = [];
  //  this.permission = this.commonService.getPagePermission("IST12").toLowerCase();
    this.userType = this.userService.getUserType();
    this.GetSummaryData();
    this.GetMasterData();
    this.collapesedOrNot = false;
    this.AttachmentForm = new UntypedFormGroup({
      DocumentType: new UntypedFormControl(""),
      DateFrom: new UntypedFormControl(null),
      DateTo: new UntypedFormControl(null),
      UploadedOn: new UntypedFormControl(""),
      Comments: new UntypedFormControl(""),
      UploadedBy: new UntypedFormControl(""),
      ApplicationID: new UntypedFormControl("")

    });
     
    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "DocumentType"
        
      },
      {
        "headerName": "Uploaded On",
        "field": "UploadedOn"
      },
     /*  {
        "headerName": "Uploaded By",
        "field": "UploadedBy"
      }, */
      {
        "headerName": "Comments",
        "field": "Comments"
      }
    ];
    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Attachment Classification",
          "field": "title",
          "type": "text"
        },
        {
          "label": "Uploaded By",
          "field": "org",
          "type": "text"
        },
        {
          "label": "Uploaded From",
          "field": "city",
          "type": "date"
        },
        {
          "label": "Uploaded To",
          "field": "city",
          "type": "date"
        }
      ]
    };

    this.permission = "";
    var lper = this.commonService.getPagePermission("IST15");
    if (lper != null && lper) {
      //;
      this.permission = lper.toLowerCase();
    }
   
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }
 
  
  onCallbackOperation(opr) {
    //;
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const modelRef= this.modalService.open(AttachmentsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content= {
      heading: 'View',
      content: { id: event.data['ID'] }
    }
  }

  add() {
    const modalRef = this['self'].modalService.open(AttachmentsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: null
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(AttachmentsViewModalComponent, {  
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: { id: RecordData['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }
  view(RecordData: any) {
    const modalRef = this['self'].modalService.open(AttachmentsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true,
     
    });
    modalRef.componentInstance.Content= {
      heading: 'View',
      content: { id: RecordData['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }
  delete(RecordData:any) {
    let id = RecordData['ID'];
    this["self"].modalRef = this["self"].modalService.open(DeleteBoxComponent, 
      { backdrop: false});
      this["self"].modalRef.componentInstance.Content =  { heading: 'Delete Attachment', 
      custommessage: 'Are you sure you want to delete the Attachment?',
      ProceedButtonName:"Delete",
       TerminateButtonName:"Cancel"}

    this["self"].modalRef.result.then(result => {
      if(result=="okclick")
      {
        this["self"].summaryService.Delete('api/ISTFileAttachments/DeleteAttachment?RecordID=' + id + '&AppID=' + this['self'].ApplicationID + '&MODULE_ID=' + this['self'].MODULE_ID).subscribe(summary => {
          if (summary["Status"] == 0) {
            this['self'].commonService.SuccessBanner("Attachment deleted successfully");
            this['self'].GetSummaryData();
          }
          else {
            this["self"].commonService.ValidationBanner("Error while deleting. Please try again after sometime");
          }
        });
      }
    })
  }
GetMasterData() {
  this.AttachmentTypeList =[];
  this.ModuleName="IST";
  this.summaryService.GetMasterScreenData("api/ISTFileAttachments/GetAttachClass?ModuleName=" + this.ModuleName).subscribe(result => {
   this.AttachmentTypeList = result["MasterData1"];
   this.AttachmentTypeList=  [{label:"All",value:"", checked: true}].concat(this.AttachmentTypeList);
  });
}
viewAll()
{
  this.SearchClear() ; 
  this.GetSummaryData() ; 
}
  GetSummaryData() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/getAttachmentsSummary?ApplicationID="+this.ApplicationID).subscribe(summary => {
      this.rowData = summary["SearchData"];
      this.AppStatus = summary["AppStatsus"];
      //;
      if (this.userType == "I") {
      this.tempoperations.push({
        "name": "View",
        "id": "view"
      });
    }
      if (this.userType == "E") {
         ;
        if (this.AppStatus != 5) {
          if (this.tempoperations.length == 0) {

            if (this.permission !== 'view' 
            && this.permission !== '' 
            && this.ApplicationID!=undefined 
            && this.ApplicationID!="" 
            && this.ApplicationID!=null) {
              this.tempoperations.push({
                "name": "Add Attachment",
                "id": "add"
              });
            }
           
            this.tempoperations.push({
              "name": "Edit",
              "id": "edit"
            });
            this.tempoperations.push({
              "name": "Delete",
              "id": "delete"
            });
            this.tempoperations.push({
              "name": "View",
              "id": "view"
            });
          }
        }
      }
     

      this.operations = this.tempoperations.map(operation => {
        return (operation &&
           (operation.id === 'add' || operation.id === 'view_modal')) ? 
           { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : 
           { name: operation.name, callback: this[operation.id], self: this }
      });
    });       
}
  getSummarySearch(searchObject) {
    this.summaryService.AdvanceSearch("api/ISTFileAttachments/getAttachmentsSearch", searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  SearchClear() {
    this.AttachmentForm.reset();
  }
  AdvanceSearch() {
    var formData = this.AttachmentForm.value;
    if (formData["DateFrom"] != null && formData["DateFrom"] != "") {
      formData["DateFromStr"] = this.datepipe.transform(formData["DateFrom"], 'dd-MMM-yyyy');
    }
    if (formData["DateTo"] != null && formData["DateTo"] != "") {
      formData["DateToStr"] = this.datepipe.transform(formData["DateTo"], 'dd-MMM-yyyy');
    }
    //formData["DocumentType"] ='Abstract Reviewed';
    formData["DateFrom"] = null;
    formData["DateTo"] = null;
    formData["ApplicationID"] = this.ApplicationID;
    this.getSummarySearch(formData);
  }

  onAdvanceSearchOperation(event) {
  }

}
